const initialstate = {
  requestCitiesData: [],
  lastDoc: null,
  hasMoreRequestCities: true,
  isFetchingRequestCities: false,
  error: null,
};
const requestCitiesReducer = (state = initialstate, action) => {
  switch (action.type) {
    case "FETCH_REQUEST_CITIES_PENDING":
      return {
        ...state,
        isFetchingRequestCities: true,
        error: null,
      };
    case "FETCH_REQUEST_CITIES_SUCCESS":
      return {
        ...state,
        requestCitiesData: action.payload.requestCitiesData,
        lastDoc: action.payload.lastDoc,
        hasMoreRequestCities: action.payload.hasMoreRequestCities,
        isFetchingRequestCities: false,
      };
    case "FETCH_REQUEST_CITIES_LOAD_MORE_SUCCESS":
      return {
        ...state,
        requestCitiesData: [
          ...state.requestCitiesData,
          ...action.payload.requestCitiesData,
        ],
        lastDoc: action.payload.lastDoc,
        hasMoreRequestCities: action.payload.hasMoreRequestCities,
        isFetchingRequestCities: false,
      };
    case "FETCH_REQUEST_CITIES_REJECTED":
      return {
        ...state,
        isFetchingRequestCities: false,
        error: action.error,
      };

       // ✅ DELETE CASE
    case "DELETE_REQUEST_CITY_SUCCESS":
      return {
        ...state,
        requestCitiesData: state.requestCitiesData.filter(
          (city) => city.id !== action.payload
        ),
      };

    // ✅ ACCEPT CASE
    case "ACCEPT_REQUEST_CITY_SUCCESS":
      return {
        ...state,
        requestCitiesData: state.requestCitiesData.filter(
          (city) => city.id !== action.payload
        ),
      };

    default:
      return {
        ...state,
      };
  }
};
export default requestCitiesReducer;
